import React, {useState, FormEvent} from "react"
import {Typography, TextField, Grid, Button, Container, Card} from "@mui/material"

import CustomerService from "../../../services/customer/CustomerService"
import {Customer} from "../../../services/customer/Customer"
import SearchResults from "../../../componenets/customer/SearchResults"
import CircularIndeterminate from "../../../componenets/feedback/CircularIndeterminate"
import {makeStyles} from "tss-react/mui"

interface Props {}

const useStyles = makeStyles()({
	header: {
		marginTop: "20px",
		marginBotton: "0px",
	},
	button: {
		backgroundColor: "#2196f3",
	},
	style: {
		fontSize: "10px",
	},
	loading: {
		size: "40",
		left: "-20",
		marginLeft: "50%",
		alignContent: "center",
	},
})

interface State {
	firstName: string
	lastName: string
	emailAddress: string
	orderNumber: string
	phoneNumber: string
}

function CustomerSearch(props: Props) {
	const {classes} = useStyles()

	const [loading, setLoading] = React.useState(false)

	const [values, setValues] = useState<State>({
		firstName: "",
		lastName: "",
		emailAddress: "",
		orderNumber: "",
		phoneNumber: "",
	})

	const defaultCustomers: Customer[] = []

	const [customers, setCustomers] = useState<Array<Customer>>(defaultCustomers)

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		event.preventDefault()
		const {name, value} = event.currentTarget
		setValues({...values, [name]: value})
	}

	const handleSubmit = async (event: FormEvent) => {
		event.preventDefault()
		const svc = new CustomerService()
		setLoading(true)
		const customers = await svc.getCustomers(
			values.firstName,
			values.lastName,
			values.emailAddress,
			values.orderNumber,
			values.phoneNumber
		)
		setLoading(false)
		setCustomers(customers)
	}

	return (
		<div>
			<Card style={{margin: "15px", paddingBottom: "15px"}}>
				<Container maxWidth={false}>
					<div className={classes.header}>
						<Typography variant="h5">Customer</Typography>
					</div>
					<form onSubmit={handleSubmit}>
						<Grid
							container
							direction="row"
							justifyContent="flex-start"
							alignItems="center"
							style={{marginTop: "12px"}}
							spacing={2}
						>
							<Grid item>
								<TextField
									id="first-name"
									label="First Name"
									variant="outlined"
									autoComplete="firstName"
									name="firstName"
									onChange={handleChange}
								/>
							</Grid>
							<Grid item>
								<TextField
									id="last-name"
									label="Last Name"
									variant="outlined"
									autoComplete="lastName"
									name="lastName"
									onChange={handleChange}
								/>
							</Grid>

							<Grid item>
								<TextField
									id="email"
									label="Email"
									variant="outlined"
									name="emailAddress"
									onChange={handleChange}
								/>
							</Grid>

							<Grid item>
								<TextField
									id="order-number"
									label="Order Number"
									variant="outlined"
									name="orderNumber"
									onChange={handleChange}
								/>
							</Grid>

							<Grid item>
								<TextField
									id="phone-number"
									label="Phone Number"
									variant="outlined"
									name="phoneNumber"
									onChange={handleChange}
								/>
							</Grid>

							<Grid item>
								<Button
									name="Submit"
									color="primary"
									variant="contained"
									size="large"
									className={classes.button}
									type="submit"
								>
									Search
								</Button>
							</Grid>
						</Grid>
					</form>
				</Container>
			</Card>

			<SearchResults customers={customers} orderNumber={values.orderNumber} />
			{loading && (
				<div className={classes.loading}>
					<CircularIndeterminate />{" "}
				</div>
			)}
		</div>
	)
}

export default CustomerSearch
